import React from 'react'
import PropTypes from 'prop-types'
import Input from 'components/common/input/Input'
import ProgressBar from 'react-bootstrap/ProgressBar'
import { CaretDown, CloudArrowUp, PaperPlaneRight } from 'phosphor-react'

function ResourceUploadPanel({
  panelId,
  title,
  isOpen,
  onToggle,
  inputName,
  inputValue,
  onInputChange,
  onAttachLink,
  items,
  onRemoveItem,
  loading,
  uploadProgress,
  getRootProps,
  getInputProps,
  uploadHint,
}) {
  return (
    <div
      className={`event-about-content-section ${
        isOpen ? 'event-about-content-section--open' : ''
      }`}
    >
      <button
        type='button'
        className={`event-about-content-header ${
          isOpen ? 'event-about-content-header--open' : ''
        }`}
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={panelId}
      >
        <p className='event-about-content-header__title'>{title}</p>
        <CaretDown
          size={24}
          className={`event-about-content-header__icon ${
            isOpen ? 'event-about-content-header__icon--open' : ''
          }`}
        />
      </button>
      {isOpen ? (
        <div id={panelId} className='event-about-content-panel'>
          <div className='event-about-content-panel__label'>Enter link</div>
          <div className='event-about-content-panel__input-row'>
            <div className='event-about-content-panel__input-wrap'>
              <Input
                name={inputName}
                value={inputValue}
                handleChange={onInputChange}
                placeholder='http://'
                label=''
              />
              <button
                type='button'
                className='event-about-content-panel__send-btn'
                onClick={onAttachLink}
                aria-label={`Attach ${title} link`}
              >
                <PaperPlaneRight size={20} weight='regular' />
              </button>
            </div>
          </div>
          {items?.length ? (
            <div className='event-about-content-tags'>
              {items.map((file) => (
                <div
                  key={`${file.link || ''}-${file.name || ''}`}
                  className='event-about-content-tag'
                >
                  <span>{file.name || file.link}</span>
                  <button
                    type='button'
                    onClick={() => onRemoveItem(file)}
                    aria-label={`Remove ${title} item`}
                  >
                    x
                  </button>
                </div>
              ))}
            </div>
          ) : null}
          <div className='event-about-content-divider'>
            <div className='event-about-content-divider__line' />
            <span>OR</span>
            <div className='event-about-content-divider__line' />
          </div>
          {loading ? (
            <div className='event-about-content-upload event-about-content-upload--loading'>
              <p>Please wait for the File to upload!</p>
              <ProgressBar
                className='event-upload-progress'
                now={uploadProgress}
                label={`${uploadProgress}%`}
              />
            </div>
          ) : (
            <div {...getRootProps()} className='event-about-content-upload'>
              <input {...getInputProps()} />
              <CloudArrowUp size={24} />
              <p>Choose a file or drag &amp; drop it here.</p>
              <span>{uploadHint}</span>
              <button type='button' className='event-about-content-upload__browse'>
                Browse File
              </button>
            </div>
          )}
        </div>
      ) : null}
    </div>
  )
}

ResourceUploadPanel.propTypes = {
  panelId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  inputName: PropTypes.string.isRequired,
  inputValue: PropTypes.string,
  onInputChange: PropTypes.func.isRequired,
  onAttachLink: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})),
  onRemoveItem: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  uploadProgress: PropTypes.number.isRequired,
  getRootProps: PropTypes.func.isRequired,
  getInputProps: PropTypes.func.isRequired,
  uploadHint: PropTypes.string,
}

ResourceUploadPanel.defaultProps = {
  inputValue: '',
  items: [],
  uploadHint: 'PDF, PPT, and PPTX formats, up to 50 MB.',
}

export default ResourceUploadPanel
